import styled from 'styled-components';

export const Avatar = styled.img`
    min-width: 180px;
    width: 180px;
    height: 180px;
    border-radius: 50%;
    vertical-align: middle;
    border-style: none;
    max-width: 100%;
`